import classNames from "classnames";
import { useParams } from 'react-router-dom';
import React from "react";
import { ReactComponent as LinkArrowIcon } from "../../icons/link_arrow.svg";
import { Item as mItem } from "../../model";
import Flag from "../Flag/Flag";
import Link from "../Link/Link";
import "./item.scss";

type Props = {
  item: mItem;
  noLeadingBorder?: boolean;
  active?: boolean;
  style?: React.CSSProperties;
  greyedOut?: boolean;
};

const Item: React.FC<Props> = ({
  item,
  noLeadingBorder = false,
  active = false,
  style = {},
  greyedOut = false,
}) => {
  const {radarName} = useParams()
  return (
    <Link
      className={classNames("item", {
        "item--no-leading-border": noLeadingBorder,
        "is-active": active,
      })}
      pageName={`/${radarName}/${item.quadrant}/${item.name}`}
      style={style}
    >
      <div
        className={classNames("item__title", {
          "greyed-out": greyedOut,
        })}
      >
        <span className="item__title__text">{item.title}</span>
        <Flag item={item} />
      </div>
      <LinkArrowIcon></LinkArrowIcon>

      {item.info && <div className="item__subtitle item__info">{item.info}</div>}
    </Link>
  )
};

export default Item;
